const initState = {
  bands: []
}

const bandReducer = (state = initState, action) => {
  switch (action.type) {
    case 'FETCH_BANDS':
      return {
        ...state, 
        bands: action.bands
      }
    default: 
      return state;
  }
}

export default bandReducer